(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49c8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49c8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8PYXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f25f9cf6fdbaf6$export$2e2bcd8739ae039; });

var $6OEk5 = parcelRequire("6OEk5");
function $66f25f9cf6fdbaf6$var$onPageLoad() {
    for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
        props[_key] = arguments[_key];
    }
    var _props = (0, $6OEk5._)(props, 2), tmp = _props[0], callable = tmp === void 0 ? function() {} : tmp, tmp1 = _props[1], delay = tmp1 === void 0 ? 50 : tmp1;
    if (delay > 0) {
        setTimeout(function() {
            return $66f25f9cf6fdbaf6$var$handlePageLoad(callable);
        }, delay);
        return;
    }
    $66f25f9cf6fdbaf6$var$handlePageLoad(callable);
}
function $66f25f9cf6fdbaf6$var$handlePageLoad(callable) {
    var preloader = document.querySelector("#preloader");
    if (preloader && preloader.style.display !== "none") {
        preloader.style.display = "none";
        preloader.style.opacity = 1;
    }
    callable();
}
var $66f25f9cf6fdbaf6$export$2e2bcd8739ae039 = $66f25f9cf6fdbaf6$var$onPageLoad;

});
parcelRegister("6OEk5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f66b0de41ced183$export$fdf2a89c76341bbf; });

var $kSKJv = parcelRequire("kSKJv");

var $2uTCM = parcelRequire("2uTCM");

var $76HkY = parcelRequire("76HkY");

var $lxJ91 = parcelRequire("lxJ91");
function $4f66b0de41ced183$export$fdf2a89c76341bbf(arr, i) {
    return (0, $kSKJv._array_with_holes)(arr) || (0, $2uTCM._iterable_to_array_limit)(arr, i) || (0, $lxJ91._unsupported_iterable_to_array)(arr, i) || (0, $76HkY._non_iterable_rest)();
}

});
parcelRegister("kSKJv", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $f33d19fbd63add3c$export$e6256bf45c68d561; });
function $f33d19fbd63add3c$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("2uTCM", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $1d1987f60f45f676$export$2fd15edff6687200; });
function $1d1987f60f45f676$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("76HkY", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $52cab5d9341bc4ea$export$60dbc22abd7da546; });
function $52cab5d9341bc4ea$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("lxJ91", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $faefb2c7d9a95775$export$a5be06335b3a083c; });

var $0XoSd = parcelRequire("0XoSd");
function $faefb2c7d9a95775$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $0XoSd._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $0XoSd._array_like_to_array)(o, minLen);
}

});
parcelRegister("0XoSd", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $002e13d75a86ff28$export$79e617b1955a2616; });
function $002e13d75a86ff28$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});




parcelRegister("jz4kC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3e4a55b6b4deff3$export$2e2bcd8739ae039; });

var $cg4HU = parcelRequire("cg4HU");

var $8wzii = parcelRequire("8wzii");

var $j1hMi = parcelRequire("j1hMi");
var $e3e4a55b6b4deff3$var$DetectBrowser = /*#__PURE__*/ function() {
    "use strict";
    function DetectBrowser() {
        (0, $cg4HU._)(this, DetectBrowser);
        this.browser = {
            name: undefined,
            version: undefined
        };
        this.minimumVersions = {
            Chrome: 90,
            Firefox: 88,
            Edge: 90,
            Opera: 74,
            Safari: 14
        };
        this._detectBrowser();
    }
    (0, $8wzii._)(DetectBrowser, [
        {
            key: "_detectBrowser",
            value: function _detectBrowser() {
                this.browser = function() {
                    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                    if (/trident/i.test(M[1])) {
                        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                        return {
                            name: "IE",
                            version: tem[1] || ""
                        };
                    }
                    if (M[1] === "Chrome") {
                        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                        if (tem != null) return {
                            name: tem[1].replace("OPR", "Opera"),
                            version: tem[2]
                        };
                    }
                    M = M[2] ? [
                        M[1],
                        M[2]
                    ] : [
                        navigator.appName,
                        navigator.appVersion,
                        "-?"
                    ];
                    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
                    return {
                        name: M[0],
                        version: M[1]
                    };
                }();
            }
        },
        {
            key: "isSupported",
            value: function isSupported() {
                if (this.minimumVersions.hasOwnProperty(this.browser.name)) {
                    if (+this.browser.version >= this.minimumVersions[this.browser.name]) return true;
                }
                return false;
            }
        },
        {
            key: "getFingerprint",
            value: function getFingerprint() {
                var canvas = document.createElement("canvas");
                var gl = canvas.getContext("webgl");
                var graphics_card = gl.getParameter(gl.RENDERER);
                var factors = [
                    window.screen.availWidth,
                    window.screen.availHeight,
                    window.screen.colorDepth,
                    navigator.userAgent,
                    navigator.platform,
                    navigator.language,
                    navigator.hardwareConcurrency,
                    navigator.cookieEnabled,
                    graphics_card
                ];
                return (0, $j1hMi.default)(factors.join("_"));
            }
        }
    ]);
    return DetectBrowser;
}();
var $e3e4a55b6b4deff3$export$2e2bcd8739ae039 = new $e3e4a55b6b4deff3$var$DetectBrowser();

});
parcelRegister("cg4HU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ecaa16d36482c75$export$2996f80ef42b8419; });
function $8ecaa16d36482c75$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8wzii", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $634cb092cc277738$export$d60067ff2358eee8; });
function $634cb092cc277738$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $634cb092cc277738$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $634cb092cc277738$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $634cb092cc277738$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("j1hMi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd8be6aa4aba10f6$export$2e2bcd8739ae039; });
function $dd8be6aa4aba10f6$export$2e2bcd8739ae039(str) {
    var seed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(var i = 0, ch; i < str.length; i++){
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

});




var $8PYXB = parcelRequire("8PYXB");

var $jz4kC = parcelRequire("jz4kC");
"use strict";
// const preloader = document.querySelector('#preloader');
// if(preloader.offsetParent === null){
//     preloader.style.display = 'none';
//     preloader.style.opacity = 1;
// }
(0, $8PYXB.default)(function() {
    if (!(0, $jz4kC.default).isSupported()) {
        var alertDiv = document.getElementById("browserAlert");
        if (!alert) {
            console.error("Unable to render browser alert.");
            return;
        }
        alertDiv.style.display = "block";
    }
});

})();
//# sourceMappingURL=app.js.map
